import { Injectable } from '@angular/core';
import { ClientInterface } from '../interfaces/client.interface';
import { FatherService } from './father.service';
import {HttpClient} from "@angular/common/http";
import {LocalstorageService} from "./localstorage.service";

@Injectable({
  providedIn: 'root'
})
export class ClientService extends FatherService{

  constructor(
    httpClient: HttpClient,
    localstorageService: LocalstorageService
  ) {
    super(httpClient, localstorageService);
  }

  createClient(data: ClientInterface) {
    return this.post('/api-license/users', data)
  }
}
